import { Store } from '@/store/type' 
import { useBaseStore } from '@/store'
import { X, ArrowDown, CirclePlus, Pencil, Trash } from 'lucide-react'
import { useOperationSegmentQuery } from '@/queries/useOperationQuery'
import { TypographyP, TypographyLarge, TypographySmall } from '@/components/ui/typography' 
import AddDialog from './components/AddDialog'
import useDisclosure from '@/hooks/useDisclosure'
import ButtonWithTooltip from '@/components/ButtonWithTooltip'
import DrowpdownMenu from '@/components/DropdownMenu'
import { useState } from 'react'
import EditDialog from './components/EditDialog'
import DeleteDialog from '../DeleteDialog'
const stateSelector = (state: Store) => ({
    isDetailOpen: state.segmentSlice.state.isDetailOpen,
    setDetailOpen: state.segmentSlice.actions.setDetailOpen
})

interface SegmentDialogProps { 
    id: number
    onEditDialogOperation: () => void
}
 
const Segment = ({ id, onEditDialogOperation } : SegmentDialogProps) => { 
    const { setDetailOpen } = useBaseStore(stateSelector)
    const [selecteSegment, setSelecteSegment ] = useState(0)

    const {
        isOpen: isAddDialogOpen,
        onClose: onAddDialogClose,
        onOpen: onAddDialogOpen,
    } = useDisclosure()

    const {
        isOpen: isEditDialogOpen,
        onClose: onEditDialogClose,
        onOpen: onEditDialogOpen,
    } = useDisclosure()

    const {
        isOpen: isDeleteDialogOpen,
        onClose: onDeleteDialogClose,
        onOpen: onDeleteDialogOpen,
    } = useDisclosure()

    const { data } = useOperationSegmentQuery(Number(id))
    
    return (
        <div className="relative z-50 h-full pl-4">
           <div className="fixed h-full w-full overflow-hidden sm:static right-0 left-0 bottom-0 top-0 z-[100] sm:w-[400px] shadow-lg border bg-gray-800 rounded-none md:rounded-lg p-4">
                <div className='flex justify-between mb-2'>
                    <TypographyLarge>Trechos</TypographyLarge>
                    <div className='flex gap-2'>
                        <ButtonWithTooltip
                            tooltipContent={<p>Novo</p>}
                            onClick={() => onAddDialogOpen()}
                            variant="ghost"
                        >
                            <CirclePlus size={18} />
                        </ButtonWithTooltip> 
                        <ButtonWithTooltip
                            tooltipContent={<p>Fechar</p>}
                            onClick={() => setDetailOpen(false)}
                            variant="ghost"
                        >
                            <X size={18} />
                        </ButtonWithTooltip>  
                    </div>
                </div>
                <div className='grid gap-2'>
                    {data?.map((item, index) => (
                        <div key={index} className='grid gap-2 border pb-2 border-gray-300'>
                            <div className='border border-b-gray-300 px-2 flex justify-between'>
                                <TypographySmall className='flex items-center'>{index + 1}º Trecho</TypographySmall>
                                <div className='flex items-center'>
                                    <TypographySmall>{item.DD_TEMPO_OPERACAO} de operação</TypographySmall>
                                    <DrowpdownMenu  
                                        actions={[
                                                {
                                                    label: 'Editar', 
                                                    action: () => { 
                                                        setSelecteSegment(item.SK_OPERACAO)
                                                        if(index==0) onEditDialogOperation()
                                                        else onEditDialogOpen()
                                                    }, 
                                                    icon: <Pencil size={14}/>
                                                },
                                                {label: 'Excluir', action: () => {
                                                    setSelecteSegment(item.SK_OPERACAO)
                                                    onDeleteDialogOpen()
                                                }, icon: <Trash size={14}/>}
                                        ]} 
                                    />
                                </div>
                            </div>
                            <div className='flex justify-center'>
                                <TypographyP className='text-center'>{item.EMPRESA_ORIGEM}</TypographyP>
                            </div>
                            <div className='flex justify-center'>
                                <ArrowDown/>
                            </div>
                            <div className='flex justify-center'>
                                <TypographyP className='text-center'>{item.EMPRESA_DESTINO}</TypographyP>
                            </div>
                        </div>
                    ))}
                </div>
           </div>
           {isEditDialogOpen && data ? (
                 <EditDialog Segment={data.find(item => item.SK_OPERACAO == selecteSegment)!} isOpen={isEditDialogOpen} onClose={onEditDialogClose}/>
            ) : null}
           <AddDialog  idOperation={id} isOpen={isAddDialogOpen} onClose={onAddDialogClose} />
           {isDeleteDialogOpen && (
                <DeleteDialog
                    ids={
                        selecteSegment && data
                            ? data.filter(item => item.SK_OPERACAO == selecteSegment)
                                  .map((row) => row.SK_OPERACAO)
                            : []
                    }
                    isOpen={isDeleteDialogOpen}
                    onClose={onDeleteDialogClose}
                />
            )}
        </div>
    )
}

export default Segment
